import { FC } from 'react';
import { useSelector } from 'react-redux';
import { State } from 'redux/initialState';
import { Council, Society } from 'types';

import CouncilsCardDetails from './CouncilsCardDetails';
import CouncilsCardActions from './CouncilsCardActions';

type CouncilsCardProps = {
  council: Council;
  society: Society;
};

const CouncilsCard: FC<CouncilsCardProps> = ({ council }) => {
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  return (
    <div className="card card-bordered sp-plan hover-shadow">
      <div className="row no-gutters">
        <CouncilsCardDetails council={council} society={actualSociety} />
        <CouncilsCardActions council={council} society={actualSociety} />
      </div>
    </div>
  );
};

export default CouncilsCard;
